import script from "./GridAdvisorComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./GridAdvisorComponent.vue?vue&type=script&setup=true&lang=js"

import "./GridAdvisorComponent.vue?vue&type=style&index=0&id=1f34cd09&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f34cd09"]])

export default __exports__